import { BCMSRecord, Workflow, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import Classes from "model";
import TASPositivePayAddChecksPage from "components/pages/TASPositivePayAddChecksPage";
import TASPositivePaySubmittedChecksPage from "components/pages/TASPositivePaySubmittedChecksPage";

// Steps of the workflow
const steps = [ 
  TASPositivePayAddChecksPage,
  TASPositivePaySubmittedChecksPage,
]; 

/**
 * @function TASPositivePayAddChecksWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "EDE Statements Enrollment" page.
 */
export default function TASPositivePayAddChecksWorkflow(props) {
    const controller = useBCMSContext();

    // Get the inital state of the workflow
    const value = getDefault(controller);

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);

    // Return the default workflow state
    return {
        ui: {
          
        },
        data: {
          
        }
    };
};